import React, { useEffect } from 'react';

const ReturnAndRefund = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <section className="section aboutPage pt-5 pb-5">
            <div className="container">
                <h1 className="hd mb-4">Return and Refund Policy</h1>
                <div className="content">
                    <p>Thank you for shopping at <strong>Paymond Services Private Limited</strong>. If, for any reason, You are not completely satisfied with a purchase We invite You to review our policy on refunds and returns. This Return and Refund Policy has been created with the help of the Free Return and Refund Policy Generator. The following terms are applicable for any products that You purchased with Us.</p>

                    <h3>1. Interpretation and Definitions</h3>
                    <p><strong>Interpretation:</strong> The words of which the initial letter is capitalized have meanings defined under the following conditions. The following definitions shall have the same meaning regardless of whether they appear in singular or in plural.</p>
                    <p><strong>Definitions:</strong> For the purposes of this Return and Refund Policy:</p>
                    <ul>
                        <li><strong>Goods</strong> refer to the items offered for sale on the Service.</li>
                        <li><strong>Company</strong> (referred to as either "the Company", "We", "Us" or "Our" in this Agreement) refers to Paymond Services Private Limited, First Floor Sh 52 Madhubani Benipatti Road Arer near SBI Bank Madhubani Bihar 847223.</li>
                        <li><strong>Orders</strong> mean a request by You to purchase Goods from Us.</li>
                        <li><strong>Service</strong> refers to the Website.</li>
                        <li><strong>Website</strong> refers to Paymond Services Private Limited, accessible.</li>
                        <li><strong>You</strong> means the individual accessing or using the Service, or the company, or other legal entity on behalf of which such individual is accessing or using the Service, as applicable.</li>
                    </ul>

                    <h3>2. Your Order Cancellation Rights</h3>
                    <p>You are entitled to cancel Your Order within 7 days without giving any reason for doing so.</p>
                    <p>The deadline for cancelling an Order is 7 days from the date on which You received the Goods or on which a third party you have appointed, who is not the carrier, takes possession of the product delivered. In order to exercise Your right of cancellation, You must inform Us of your decision by means of a clear statement. You can inform us of your decision by:</p>
                    <ul>
                        <li><strong>By email:</strong> paymondtechnologies@gmail.com</li>
                    </ul>
                    <p>We will reimburse You no later than 14 days from the day on which We receive the returned Goods. We will use the same means of payment as You used for the Order, and You will not incur any fees for such reimbursement.</p>

                    <h3>3. Conditions for Returns</h3>
                    <p>In order for the Goods to be eligible for a return, please make sure that:</p>
                    <ul>
                        <li>The Goods were purchased in the last 7 days</li>
                        <li>The Goods are in the original packaging</li>
                    </ul>
                    <p>The following Goods cannot be returned:</p>
                    <ul>
                        <li>The supply of Goods made to Your specifications or clearly personalized.</li>
                        <li>The supply of Goods which according to their nature are not suitable to be returned, deteriorate rapidly or where the date of expiry is over.</li>
                        <li>The supply of Goods which are not suitable for return due to health protection or hygiene reasons and were unsealed after delivery.</li>
                        <li>The supply of Goods which are, after delivery, according to their nature, inseparably mixed with other items.</li>
                    </ul>
                    <p>We reserve the right to refuse returns of any merchandise that does not meet the above return conditions in our sole discretion. Only regular priced Goods may be refunded. Unfortunately, Goods on sale cannot be refunded. This exclusion may not apply to You if it is not permitted by applicable law.</p>


                    <h3>4. Returning Goods</h3>
                    <p>You are responsible for the cost and risk of returning the Goods to Us. You should send the Goods at the following address:</p>
                    <p><strong>First Floor Sh 52 Madhubani Benipatti Road Arer near SBI Bank Madhubani Bihar 847223</strong></p>
                    <p>We cannot be held responsible for Goods damaged or lost in return shipment. Therefore, We recommend an insured and trackable mail service. We are unable to issue a refund without actual receipt of the Goods or proof of received return delivery.</p>


                    <h3>5. Gifts</h3>
                    <p>If the Goods were marked as a gift when purchased and then shipped directly to you, You'll receive a gift credit for the value of your return. Once the returned product is received, a gift certificate will be mailed to You.</p>
                    <p>If the Goods weren't marked as a gift when purchased, or the gift giver had the Order shipped to themselves to give it to You later, We will send the refund to the gift giver.</p>


                    <h3>6. Refund Timeline</h3>
                    <p>Your amount will be refunded to your bank account within 5 to 6 working days.</p>
                    <p>Refund amount via the same Transaction mode.</p>


                    <h3>7. Contact Us</h3>
                    <p>If you have any questions about our Returns and Refunds Policy, please contact us:</p>
                    <ul>
                        <li><strong>By email:</strong> paymondtechnologies@gmail.com</li>
                    </ul>

                    <p>Thank you for shopping with Paymond Services Private Limited!</p>
                </div>
            </div>
        </section>
    );
}

export default ReturnAndRefund;
